module.exports = __webpack_public_path__ + "media/azjsjtxcsp.8b7a05dc.mp4";